import { api } from '../../lib/api';
import type {
  AccountConnectionHealth,
  CaptureResult,
  ConnectionHealthReport,
} from '../../types/connectionHealth';

// Thin wrappers over the shared api() helper (auto-attaches the Firebase token).

export function getConnectionHealthReport(): Promise<ConnectionHealthReport> {
  return api<ConnectionHealthReport>('/api/connection-health');
}

export function runConnectionHealthCheck(): Promise<CaptureResult> {
  return api<CaptureResult>('/api/connection-health/check', { method: 'POST' });
}

export function getAccountConnectionHealth(
  accountId: string,
): Promise<{ health: AccountConnectionHealth | null }> {
  return api<{ health: AccountConnectionHealth | null }>(
    `/api/connection-health/account/${encodeURIComponent(accountId)}`,
  );
}
